module.exports = __webpack_public_path__ + "img/thalheim_fresken.8573e43a.jpg";